import React, {createContext, useContext} from 'react'

const PlayerContext = createContext();

const PlayerProvider = (props) => {
  const { children, youtubePlayer } = props


  return <PlayerContext.Provider value={{ youtubePlayer }}>{children}</PlayerContext.Provider>;
}

const usePlayer = () => useContext(PlayerContext);

export { PlayerProvider, usePlayer };